
const digest = '009d426cdf96cea19a834fec0c4ef94d9cc4012ec19f985e2b58d703ee6c8b08';
const classes = {"wrapper":"_wrapper_ke2kb_1","iconWrapper":"_iconWrapper_ke2kb_11","content":"_content_ke2kb_17","title":"_title_ke2kb_22","description":"_description_ke2kb_26","arrowButton":"_arrowButton_ke2kb_29"};
const css = `._wrapper_ke2kb_1 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 15px;
  border-radius: 15px;
  border: 1px solid #d7d3f7;
  align-items: center;
  cursor: pointer;
}
._wrapper_ke2kb_1 ._iconWrapper_ke2kb_11 {
  height: 120px;
}
._wrapper_ke2kb_1 ._iconWrapper_ke2kb_11 img {
  height: 100%;
}
._wrapper_ke2kb_1 ._content_ke2kb_17 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_ke2kb_1 ._content_ke2kb_17 ._title_ke2kb_22 {
  color: rgb(6, 42, 96);
  font-weight: 600;
}
._wrapper_ke2kb_1 ._content_ke2kb_17 ._description_ke2kb_26 {
  color: rgb(33, 35, 87);
}
._wrapper_ke2kb_1 ._arrowButton_ke2kb_29 {
  height: 50px;
  width: 50px;
  min-width: 50px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #e5f3ff;
  background: linear-gradient(0deg, #e5f3ff 0, #f4faff 100%);
  position: relative;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  